import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import Loader from './components/common/Loader.jsx';
import ErrorBoundary from './components/common/ErrorBoundary.jsx';
import './index.css';
import { installGlobalErrorReporting } from './utils/errorReporter.js';

installGlobalErrorReporting();

const isTournamentRoute =
  window.location.pathname.startsWith('/tournament') ||
  window.location.pathname.startsWith('/rooms');
const loaderElement = document.getElementById('loader');
let loaderRoot = null;

if (loaderElement && !isTournamentRoute) {
  loaderRoot = createRoot(loaderElement);
  loaderRoot.render(<Loader />);
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

if (loaderRoot) {
  loaderRoot.unmount();
} else if (loaderElement) {
  window.requestAnimationFrame(() => loaderElement.remove());
}
